import {Card, ScorecardRow} from "./scorecard-model";

export interface CourseCard extends Card {
    hole: ScorecardRow<string, string>,
    par: ScorecardRow<AltValue, AltValue>,
    strokeIndex: ScorecardRow<AltValue, AltValue>
}

export interface AltValue {
    type: AltValueType,
    value: string,
    altValue: string
}

export enum AltValueType {
    Single = "Single",
    Pair = "Pair"
}